import { enableProdMode, CSP_NONCE } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const nonce = document.querySelector('app-root')?.getAttribute('ngCspNonce') ?? '';

platformBrowserDynamic([{ provide: CSP_NONCE, useValue: nonce }]).bootstrapModule(AppModule)
  .catch(err => console.error(err));
